import React, { Component } from 'react'
import { UserDataContext } from './withAuth'

export default function withUserData(ComponentWithUserData) {
    return class extends Component {
        static contextType = UserDataContext

        render() {
            return (
                <ComponentWithUserData
                    {...this.props}
                    userData={this.context}
                />
            )
        }
    }
}
